import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Skills`}</h2>
    <ProjectCard title="Backend" link="https://www.linkedin.com/in/patrick-delos-santos/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
PHP Laravel, Laravel-excel, Laravel DataTables, Basic FFMPEG 
    </ProjectCard>
    <ProjectCard title="Frontend" link="https://www.linkedin.com/in/patrick-delos-santos/" bg="linear-gradient(to right, #662d8c 0%, #ed1e79 100%)" mdxType="ProjectCard">
VueJs, ReactJs, GatsbyJs, HTML5, CSS3, Bootstrap 3 and 4, JQuery 
    </ProjectCard>
    <ProjectCard title="CMS" link="https://www.linkedin.com/in/patrick-delos-santos/" bg="linear-gradient(to right, #009245 0%, #fcee21 100%)" mdxType="ProjectCard">
Wordpress, Woocommerce, Opencart
    </ProjectCard>
    <ProjectCard title="Graphics" link="https://www.linkedin.com/in/patrick-delos-santos/" bg="linear-gradient(to right, #d585ff 0%, #00ffee 100%)" mdxType="ProjectCard">
Adobe Photoshop, Figma
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      